import {HttpClient, HttpStatusCode} from 'data/protocols/http';
import {APIError} from 'data/errors/api-error';
import {
	PostHealthRequestSchedule,
	PostHealthRequestScheduleModel,
	PostHealthRequestScheduleParams,
} from 'domain/usecases/private/booking-flow/health/post-health-request-schedule';

export class RemotePostHealthRequestSchedule implements PostHealthRequestSchedule {
	constructor(
		private readonly url: string,
		private readonly httpClient: HttpClient<PostHealthRequestScheduleModel>,
	) {}

	async post(params: PostHealthRequestScheduleParams): Promise<PostHealthRequestScheduleModel> {
		const httpResponse = await this.httpClient.request({
			url: this.url,
			method: 'post',
			body: params,
		});

		switch (httpResponse.status) {
			case HttpStatusCode.ok:
				return httpResponse.data;
			case HttpStatusCode.created:
				return httpResponse.data;
			case HttpStatusCode.noContent:
				return httpResponse.data;
			default: {
				throw new APIError(httpResponse.status, httpResponse.data);
			}
		}
	}
}
